export default __webpack_public_path__ + "static/media/COVIDDashboard_SoftwareArch.ec3f4296.png";